import Axios from 'axios'
import {partnerTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_partner_types (context) {
    Axios.get(partnerTypeUrls.getAllPartnerTypes).then(function (response) {
      context.commit('GET_ALL_PARTNER_TYPES', response.data)
    })
  },
  get_partner_types (context, publicId) {
    Axios.get(partnerTypeUrls.getPartnerTypes + publicId).then(function (response) {
      context.commit('GET_PARTNER_TYPES', response.data)
    })
  },
  get_deleted_partner_types (context) {
    Axios.get(partnerTypeUrls.getDeletedPartnerType).then(function (response) {
      context.commit('GET_DELETED_PARTNER_TYPES', response.data)
    })
  },
  get_partner_type (context, publicId) {
    Axios.get(partnerTypeUrls.getPartnerType + publicId).then(function (response) {
      context.commit('GET_PARTNER_TYPE', response.data)
    })
  },
  post_partner_type (context, data) {
    Axios.post(partnerTypeUrls.postPartnerType, data).then(function () {
      context.dispatch('get_all_partner_types')
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_partner_type (context, data) {
    Axios.post(partnerTypeUrls.editPartnerType + data.public_id, data).then(function () {
      context.dispatch('get_all_partner_types')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_partner_type (context, publicId) {
    var postData = {
      session_id: localStorage.getItem('lkjhgfdsa')
    }
    Axios.patch(partnerTypeUrls.deletePartnerType + publicId, postData).then(function () {
      context.dispatch('get_all_partner_types')
    })
  },
  restorePartnerType (context, publicId) {
    Axios.get(partnerTypeUrls.restorePartnerType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PARTNER_TYPES', response.data)
      router.push({
        name: 'Module.PartnerTypes'
      })
    })
  }
}
